import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IProductGroupImagesModel } from '../models/requestModels'
import { IProductGroupImageList } from '../models/responseModel'

export class DeleteProductGroupImageApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/brand/DeleteProductGroupImage',
      requesterInfo,
    })
  }
  public async deleteImage(req: string): Promise<IProductGroupImageList[]> {
    return await this.postAsync<IProductGroupImageList[]>(req)
  }
}
